export default class Helper {

    static isEmpty(obj) {
        for(let key in obj) {
            if(obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    static inArray(value, array) {
        return array.includes(value);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/core/Helper.js